const UNREAD_TITLE_PREFIX_PATTERN = /^\(\d+\)\s+/;
const INCOMING_CALL_TITLE_PREFIX = 'Incoming call - ';

const titleState = {
  unreadCount: 0,
  hasIncomingCall: false,
};

const stripMessengerTitlePrefixes = (title) =>
  `${title || ''}`
    .replace(UNREAD_TITLE_PREFIX_PATTERN, '')
    .replace(INCOMING_CALL_TITLE_PREFIX, '');

const applyMessengerDocumentTitle = () => {
  if (typeof document === 'undefined') return;

  const baseTitle = stripMessengerTitlePrefixes(document.title);
  const unreadCount = Number(titleState.unreadCount) || 0;
  const unreadPrefix = unreadCount > 0 ? `(${unreadCount}) ` : '';
  const callPrefix = titleState.hasIncomingCall ? INCOMING_CALL_TITLE_PREFIX : '';

  document.title = `${unreadPrefix}${callPrefix}${baseTitle}`;
};

const setMessengerTitleUnreadCount = (unreadCount) => {
  titleState.unreadCount = Number(unreadCount) || 0;
  applyMessengerDocumentTitle();
};

const setMessengerTitleIncomingCall = (hasIncomingCall) => {
  titleState.hasIncomingCall = Boolean(hasIncomingCall);
  applyMessengerDocumentTitle();
};

const clearMessengerDocumentTitle = () => {
  if (typeof document === 'undefined') return;
  titleState.unreadCount = 0;
  titleState.hasIncomingCall = false;
  document.title = stripMessengerTitlePrefixes(document.title);
};

export {
  clearMessengerDocumentTitle,
  setMessengerTitleIncomingCall,
  setMessengerTitleUnreadCount,
  stripMessengerTitlePrefixes,
};
